module.exports = __webpack_public_path__ + "img/msep.ca420dc8.png";